module.exports = __webpack_public_path__ + "img/64.b2b1e824.png";